export default "__VITE_ASSET__14152bf3__"